export const commonRecord =   {
    // 患者基本信息
    //主要是做中文映射的 
    'patientName': '患者姓名',
    'patientname': '患者姓名',
    'name': '患者姓名',
    'patient_name': '患者姓名',
    'patientage': '年龄',
    'age': '年龄',
    'patient_age': '年龄',
    'gender': '性别',
    'sex': '性别',
    'patient_gender': '性别',
    'phone': '联系电话',
    'mobile': '联系电话',
    'telephone': '联系电话',
    
    // 症状相关
    'symptoms': '主要症状',
    'symptom': '主要症状',
    'mainsymptom': '主要症状',
    'mainsymptoms': '主要症状',
    'currentSymptoms': '现病史',
    'currentsymptoms': '现病史',
    'chiefComplaint': '主诉',
    'chiefcomplaint': '主诉',
    'chief_complaint': '主诉',
    'presentIllness': '现病史',
    'presentillness': '现病史',
    'present_illness': '现病史',
    
    // 病史相关
    'pastHistory': '既往史',
    'pasthistory': '既往史',
    'past_history': '既往史',
    'pastMedicalHistory': '既往病史',
    'pastmedicalhistory': '既往病史',
    'familyHistory': '家族史',
    'familyhistory': '家族史',
    'family_history': '家族史',
    'personalHistory': '个人史',
    'personalhistory': '个人史',
    'personal_history': '个人史',
    'menstrualHistory': '月经史',
    'menstrualhistory': '月经史',
    'menstrual_history': '月经史',
    'marriageHistory': '婚育史',
    'marriagehistory': '婚育史',
    'marriage_history': '婚育史',
    'allergicHistory': '过敏史',
    'allergichistory': '过敏史',
    'allergic_history': '过敏史',
    'allergy': '过敏史',
    
    // 检查相关
    'physicalExamination': '体格检查',
    'physicalexamination': '体格检查',
    'physical_examination': '体格检查',
    'examination': '体格检查',
    'laboratory_tests': '实验室检查',
    'laboratorytests': '实验室检查',
    'lab_tests': '实验室检查',
    'labtests': '实验室检查',
    'imaging_studies': '影像学检查',
    'imagingstudies': '影像学检查',
    'imaging': '影像学检查',
    
    // 诊断治疗
    'diagnosis': '诊断',
    'preliminary_diagnosis': '初步诊断',
    'preliminarydiagnosis': '初步诊断',
    'initial_diagnosis': '初步诊断',
    'initialdiagnosis': '初步诊断',
    'final_diagnosis': '最终诊断',
    'finaldiagnosis': '最终诊断',
    'treatment': '治疗方案',
    'treatment_plan': '治疗方案',
    'treatmentplan': '治疗方案',
    'therapy': '治疗方案',
    'medication': '用药建议',
    'medicine': '用药建议',
    'drug': '用药建议',
    'prescription': '处方',
    'advice': '医嘱',
    'medical_advice': '医嘱',
    'medicaladvice': '医嘱',
    'followUp': '复诊建议',
    'followup': '复诊建议',
    'follow_up': '复诊建议',
    'notes': '备注',
    'note': '备注',
    'remark': '备注',
    'remarks': '备注',
    'comment': '备注',
    'comments': '备注'
  }